import * as cookieMessageActions from "../../state/actions/cookieMessage.actions";

const INITIAL_STATE = {
  isOpen: true,
  isClosable: false,
  isSettingsOpen: false,
  selectedCookie: null
};

export function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case cookieMessageActions.INITIALIZE:
      return {
        ...state,
        ...action.payload
      };
    case cookieMessageActions.SET_OPEN_STATE:
      return {
        ...state,
        isOpen: action.payload
      };
    case cookieMessageActions.TOGGLE_SETTINGS:
      return {
        ...state,
        isSettingsOpen: !state.isSettingsOpen
      };
    case cookieMessageActions.SET_SELECTED:
      return {
        ...state,
        selectedCookie: action.payload
      };
    case cookieMessageActions.SET_CLOSABLE_STATE:
      return {
        ...state,
        isClosable: action.payload
      };
    default:
      return state;
  }
}

export const isOpen = state => state.isOpen;
export const isSettingsOpen = state => state.isSettingsOpen;
export const isClosable = state => state.isClosable;
export const getSelectedCookie = state => state.selectedCookie;
